import { createContext, useContext } from 'react'

// Where a template page wants the node configuration panel: an element beside
// its content, so the content narrows instead of sitting under an overlay.
// Without one, the host falls back to a sheet over the editor.
export const NodeConfigPanelSlotContext = createContext<HTMLElement | null>(
  null
)

export function useNodeConfigPanelSlot(): HTMLElement | null {
  return useContext(NodeConfigPanelSlotContext)
}
